module.exports = __webpack_public_path__ + "static/media/traffic-light-slow.836b6db3.svg";